<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents no_height">
                    <div class="title">
                        {{ this.$route.meta.title }}
                        <div class="clear"></div>
                    </div>
                    <example-write-component :exampleType="'updateExample'" :exampleKey="exampleKey"></example-write-component>
                </div>
                <div class="content_btn_wrap text_center">
                    <el-button type="primary" @click="save()">저장</el-button>
                    <el-button type="danger" @click="deleteConfirm(exampleKey)">삭제</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ExampleWriteComponent from "@/components/example/ExampleWriteComponent";
import EventBus from "@/mixins/event-bus";

export default {
    name: "ExampleWordDetail",
    components: {ExampleWriteComponent},
    inject: [],
    provide() {
        return {};
    },
    props: {},
    data() {
        return {
            exampleKey: this.$route.params.idx
        };
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        save() {
            EventBus.$emit('writeExample')
        },
        deleteConfirm(key){
            key = Number(key);
            let keyArr = []
            keyArr.push(key)
            console.log(keyArr)
            EventBus.$emit('deleteExampleData', keyArr);
        }
    },
    watch: {}
}
</script>

<style scoped>

</style>